import types from "./types";
import service from "./service";

const getNotifications = () => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_NOTIFICATIONS });
        service
            .getNotifications(getState().notification.pagination.actualPage, getState().notification.filters)
            .then(result => {
                dispatch(getAllSuccess(result.list));
                dispatch(updatePagination(result.pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const changePage = page => {
    return dispatch => {
        dispatch(changeNotificationsPage({ page: page }));
        dispatch(getNotifications());
    };
};
const updateFilter = filters => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeNotificationsPage({ page: 1 }));
        dispatch(getNotifications());
    };
};

const toggleNotificationActive = (notification_id, is_active) => {
    return dispatch => {
        dispatch(toggleNotificationActiveStart({ notification_id }));
        return service
            .updateNotification(notification_id, { is_active: !is_active })
            .then(result => {
                dispatch(toggleNotificationActiveSuccess(result));
                dispatch(getNotifications());
                dispatch(fetchActiveAlert());
            })
            .catch(error => dispatch(toggleNotificationActiveFail({ notification_id, error })));
    };
};

const getAllSuccess = payload => ({
    type: types.GET_NOTIFICATIONS_SUCCESS,
    payload
});
const getAllFail = error => ({
    type: types.GET_NOTIFICATIONS_FAIL,
    payload: error
});

const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

const changeNotificationsPage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

const toggleNotificationActiveStart = payload => ({
    type: types.TOGGLE_NOTIFICATION_ACTIVE,
    payload
});

const toggleNotificationActiveSuccess = payload => ({
    type: types.TOGGLE_NOTIFICATION_ACTIVE_SUCCESS,
    payload
});

const toggleNotificationActiveFail = payload => ({
    type: types.TOGGLE_NOTIFICATION_ACTIVE_FAIL,
    payload
});

const fetchActiveAlert = () => dispatch => {
    service
        .getActiveAlert()
        .then(result => dispatch({ type: types.FETCH_ACTIVE_ALERT_SUCCESS, payload: result }))
        .catch(() => {});
};

const saveNotification = (id, body) => dispatch => {
    dispatch({ type: types.SAVE_NOTIFICATION });
    const call = id
        ? service.updateNotification(id, body)
        : service.createNotification(body);
    return call
        .then(result => {
            dispatch({ type: types.SAVE_NOTIFICATION_SUCCESS, payload: result });
            dispatch(getNotifications());
            dispatch(fetchActiveAlert());
        })
        .catch(error => {
            dispatch({ type: types.SAVE_NOTIFICATION_FAIL, payload: error });
            return Promise.reject(error);
        });
};

const openAlertViewer  = () => ({ type: types.OPEN_ALERT_VIEWER });
const closeAlertViewer = () => ({ type: types.CLOSE_ALERT_VIEWER });
const clearSaveError   = () => ({ type: types.CLEAR_SAVE_ERROR });

export default {
    getNotifications,
    changePage,
    updateFilter,
    toggleNotificationActive,
    fetchActiveAlert,
    saveNotification,
    openAlertViewer,
    closeAlertViewer,
    clearSaveError
};
